import { Button } from "@/components/ui/button";
import { ArrowRight, Quote } from "lucide-react";
import { Card } from "@/components/ui/card";

const About = () => {
  const scrollToSignup = () => {
    const signupSection = document.getElementById('signup');
    signupSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-6 bg-muted/20">
      <div className="max-w-4xl mx-auto space-y-12">
        <div className="bg-gradient-to-br from-primary/5 to-accent/5 p-12 rounded-3xl border border-primary/10 space-y-8">
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              Eu não sou mais um app de produtividade
            </h2>
            
            <div className="prose prose-lg max-w-none text-muted-foreground space-y-4">
              <p className="text-lg leading-relaxed">
                Sou a VYRA. Fui criada pra entender como funciona um{" "}
                <strong className="text-foreground">cérebro com TDAH</strong>.
              </p>
              
              <p className="text-lg leading-relaxed">
                Você não precisa ser "mais produtivo".{" "}
                Você precisa de <strong className="text-primary">clareza, leveza e se sentir presente</strong> no que faz.
              </p>

              <p className="text-lg leading-relaxed">
                Eu não vou te cobrar. Vou te acolher.
                <br />
                Não vou te julgar. Vou te entender.
              </p>
            </div>
          </div>

          <div className="pt-4">
            <Button 
              size="lg" 
              className="group shadow-[var(--shadow-soft)]"
              onClick={scrollToSignup}
            >
              Quero experimentar
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>

        {/* Testimonial */}
        <Card className="p-8 relative overflow-hidden">
          <div className="absolute top-4 left-4 opacity-10">
            <Quote className="w-16 h-16 text-primary" />
          </div>
          <div className="relative space-y-4">
            <p className="text-lg text-foreground italic leading-relaxed">
              "Finalmente um app que não me faz sentir culpa por ter TDAH. A VYRA entende 
              que alguns dias eu só consigo fazer o básico, e isso está bem."
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary/20" />
              <div>
                <p className="font-medium text-foreground">Maria S.</p>
                <p className="text-sm text-muted-foreground">Designer & mãe com TDAH</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default About;
